import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-up-down-chevron-icon',
  imports: [],
  templateUrl: './up-down-chevron-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './up-down-chevron-icon.component.scss',
})
export class UpDownChevronIconComponent {}
